<template>
  <div class="container-box">
    <h2 class="title-type-1">
      계정 권한 관리
      <v-tooltip right content-class="tooltip-custom-1">
        <template v-slot:activator="{ on, attrs }">
          <v-icon class="ico-help-1" v-bind="attrs" v-on="on">mdi-help</v-icon>
        </template>
        <span
          >Admin 접속계정 및 계정별 권한을 관리하는 메뉴<br />Owner / Admin 권한
          계정에게만 노출 됩니다.</span
        >
      </v-tooltip>
    </h2>

    <!-- search-box-1 -->
    <div class="search-box-1 mb-n3">
      <div class="search">
        <div class="sel" style="width: 144px">
          <v-select
            :items="searchSel"
            :label="searchSel[0]"
            v-model="searchSelChoice"
            item-color="#000"
            class="input-custom-1"
            height="40px"
            solo
            @change="searchAuthType"
          ></v-select>
        </div>
      </div>
      <div class="btn">
        <span>
          <v-btn
            large
            depressed
            dark
            max-height="40px"
            color="#ff5959"
            class="button-type-1 mr-2"
            @click="onlyOwnerPermmition('codeReset')"
          >
            보안 코드 리셋
          </v-btn>
        </span>

        <v-btn
          large
          depressed
          max-height="40px"
          color="#fecd06"
          @click="onlyOwnerPermmition('register')"
        >
          <v-icon left> mdi-plus </v-icon>
          계정 등록
        </v-btn>
      </div>
    </div>
    <!-- //search-box-1 -->
    <p class="text-total-1 mb-3">
      총 <strong>{{ totalList }}</strong
      >건 입니다.
    </p>
    <div class="table-wrap" style="position: relative">
      <v-data-table
        :headers="boardHeaders"
        :items="customBoardLists"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        class="board-list-1"
        hide-default-footer
        @page-count="pageCount = $event"
        :search="searchText"
      >
        <template v-slot:top>
          <div
            class="input"
            style="position: absolute; left: 152px; top: -84px"
          >
            <v-text-field
              label="회사명"
              class="input-custom-1"
              height="40px"
              solo
              v-model="searchText"
              append-icon="mdi-magnify"
              single-line
              hide-details
            ></v-text-field>
            <!-- <v-btn icon class="btn">
						<v-icon>mdi-magnify</v-icon>
					</v-btn> -->
          </div>
        </template>
        <template v-slot:body="{ items, headers }">
          <tbody v-if="items.length > 0">
            <tr v-for="(item, index) in items" :key="index">
              <td>
                {{ item.no }}
              </td>
              <td>
                <template v-if="item.type === 'owner'">
                  <span style="color: #e6b905" class="text-capitalize">{{
                    item.type
                  }}</span>
                </template>
                <template v-else>
                  <span class="text-capitalize">{{ item.type }}</span>
                </template>
              </td>
              <td>
                {{ item.advertiser_name }}
              </td>
              <td>
                {{ item.manager_name }}
              </td>
              <td>
                {{ item.authorize_code || '-' }}
              </td>
              <td>
                {{ item.recent_at | moment('YYYY.MM.DD HH:mm:ss') }}
              </td>
              <td>
                <span v-if="item.is_valid === 'Y'"> 활성</span>
                <span v-else> 비활성</span>
              </td>
              <td>
                <router-link
                  :to="`/account/${item.id}`"
                  style="color: transparent"
                  ><v-icon color="#fecd00">mdi-cog-outline</v-icon>
                </router-link>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td :colspan="headers.length" style="text-align: center">
                검색결과가 없습니다.
              </td>
            </tr>
          </tbody>
        </template>
        <template v-slot:no-data> 목록이 없습니다. </template>
      </v-data-table>
    </div>

    <div class="pagination-1">
      <div class="sel-sort">
        <span>페이지당 행개수</span>
        <v-select
          :items="pageSel"
          :label="pageSel[0]"
          v-model="pageSelChoice"
          item-color="#000"
          class="input-custom-1"
          height="40px"
          solo
          @change="itemsPerPage = parseInt($event, 10)"
        ></v-select>
      </div>

      <v-btn
        icon
        :plain="true"
        :ripple="false"
        :disabled="page == 1"
        @click="page = 1"
      >
        <v-icon>mdi-page-first</v-icon>
      </v-btn>

      <v-pagination
        v-model="page"
        :length="pageCount"
        total-visible="10"
        color="transparent"
      ></v-pagination>

      <v-btn
        icon
        :plain="true"
        :ripple="false"
        :disabled="page == pageCount"
        @click="page = pageCount"
      >
        <v-icon>mdi-page-last</v-icon>
      </v-btn>
    </div>
    <SystemAlert v-model="showCodeResetAlert">
      <div slot="noti-text">보안코드를 리셋하시겠습니까?</div>
      <div slot="noti-btns">
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fecd06"
          class="button-type-1"
          @click.stop="codeReset"
        >
          확인
        </v-btn>
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fff"
          class="button-type-1 ml-2"
          @click.stop="showCodeResetAlert = false"
        >
          취소
        </v-btn>
      </div>
    </SystemAlert>
    <SystemAlert v-model="showSystemAlert">
      <div slot="noti-text" v-html="logResult"></div>
      <div slot="noti-btns">
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fecd06"
          class="button-type-1"
          @click.stop="closePopup"
        >
          확인
        </v-btn>
      </div>
    </SystemAlert>
  </div>
</template>

<script>
import { userList } from '@/api/account';
import { authCodereset } from '@/api/auth';
import SystemAlert from '~@/modal/SystemAlert.vue';
import bus from '@/utils/bus';
import _ from 'lodash';

export default {
  components: {
    SystemAlert,
  },
  data: () => ({
    searchText: '',
    searchSel: ['전체', 'Owner', 'Admin', 'Developer', 'User'],
    searchSelChoice: '전체',
    pageSel: ['10', '25', '50', '100'],
    pageSelChoice: '10',
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    boardHeaders: [
      {
        text: 'No',
        value: 'no',
        width: '10%',
        sortable: false,
        filterable: false,
      },

      {
        text: '분류',
        value: 'type',
        width: '10%',
        sortable: false,
        filterable: false,
      },
      {
        text: '소속',
        value: 'advertiser_name',
        width: '15%',
        sortable: false,
      },
      {
        text: '담당자 성명',
        value: 'manager_name',
        width: '15%',
        sortable: false,
        filterable: false,
      },
      {
        text: '보안코드',
        value: 'authorize_code',
        sortable: false,
        filterable: false,
      },
      {
        text: '최근 활동 일시',
        value: 'recent_at',
        width: '15%',
        sortable: false,
        filterable: false,
      },
      {
        text: '상태',
        value: 'is_valid',
        sortable: false,
        filterable: false,
      },
      {
        text: '관리',
        value: 'action',
        sortable: false,
        filterable: false,
      },
    ],
    boardLists: [],
    originList: [],
    showCodeResetAlert: false,
    showSystemAlert: false,
    logResult: '',
  }),
  computed: {
    isOwner() {
      return this.$store.getters.isOwner;
    },
    totalList() {
      let result = 0;
      if (this.boardLists.length > 0) {
        result = this.boardLists.length;
      }
      return result;
    },
    customBoardLists() {
      for (let num = 0; num < this.boardLists.length; num++) {
        let item = this.boardLists[num];
        item.no = this.boardLists.length - num;
        if (item.hasOwnProperty('advertiser')) {
          item.advertiser_name = this.boardLists[num].advertiser.name;
        } else {
          item.advertiser_name = '-';
        }
      }
      return this.boardLists;
    },
  },
  methods: {
    async getUserList() {
      try {
        const { data } = await userList();
        const getUserList = data.list;

        getUserList.sort(function (a, b) {
          if (a.create_at > b.create_at) {
            return -1;
          }
          if (a.create_at < b.create_at) {
            return 1;
          }
          // a must be equal to b
          return 0;
        });
        this.boardLists = getUserList;
        this.originList = getUserList;
        bus.$emit('end:spinner');
      } catch (error) {
        bus.$emit('end:spinner');
        console.log(error.response);
      }
    },
    enterUserDetail(id) {
      this.$router.push({ path: `/account/update/${id}` });
    },
    searchAuthType() {
      if (this.searchSelChoice === '전체') {
        this.boardLists = this.originList;
        return;
      }
      const auth = this.searchSelChoice.toLowerCase();
      this.boardLists = this.originList.filter(item => item.type === auth);
    },
    async codeReset() {
      try {
        const { data } = await authCodereset();
        if (data.result === 'success') {
          this.resultType = data.result;
          this.showSystemAlert = true;
          this.showCodeResetAlert = false;
          this.logResult = '보안코드가 리셋되었습니다.';
        }
        bus.$emit('end:spinner');
      } catch (error) {
        bus.$emit('end:spinner');
        console.log(error.response);
      }
    },
    closePopup() {
      this.showSystemAlert = false;
      this.getUserList();
    },
    onlyOwnerPermmition(type) {
      if (this.isOwner) {
        if (type === 'codeReset') {
          this.showCodeResetAlert = true;
        } else {
          this.$router.push(`/account/register`);
        }
      } else {
        this.showSystemAlert = true;
        this.logResult =
          '접속하신 계정은 관리 권한이 없습니다. <br/>VX사업부에 문의 부탁드립니다';
      }
    },
  },

  created() {
    bus.$emit('start:spinner');
    this.getUserList();
  },
};
</script>

<style></style>
